export type IncidentPetRole = "aggressor" | "victim" | "involved";

export type IncidentPetOption = {
  petId: string;
  petName: string;
  ownerName?: string | null;
  photoPath?: string | null;
  isPresent?: boolean;
};

export type IncidentParticipantDraft = {
  petId: string;
  role: IncidentPetRole;
};

export const sortIncidentPetOptions = (
  options: IncidentPetOption[],
  presentPetIds: Set<string>,
) => [...options].sort((a, b) => {
  const presence = Number(presentPetIds.has(b.petId)) - Number(presentPetIds.has(a.petId));
  return presence || a.petName.localeCompare(b.petName, "pt-BR");
});

export const buildIncidentRpcArgs = (input: {
  reservationId: string;
  day: string;
  time: string;
  typeId: string;
  description: string;
  primaryPetRole: IncidentPetRole;
  participants: IncidentParticipantDraft[];
}) => ({
  p_stay_reservation_id: input.reservationId,
  p_log_date: input.day,
  p_logged_at: input.time,
  p_observation_type_id: input.typeId,
  p_description: input.description.trim(),
  p_primary_pet_role: input.primaryPetRole,
  p_other_pets: input.participants.map(({ petId, role }) => ({ pet_id: petId, role })),
});
